<template>
  <svg
    class="chevron"
    :class="[{ pointer: pointer}, 'chevron-' + orientation ]"
    :height="iconSize"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 6C7 5.86637 6.97549 5.73942 6.92646 5.61915C6.87297 5.50334 6.79051 5.39198 6.67908 5.28508L1.53104 0.253897C1.36167 0.0846314 1.15441 -5.11038e-07 0.909266 -5.32469e-07C0.739893 -5.47276e-07 0.588349 0.0400881 0.454633 0.120266C0.316461 0.200445 0.20726 0.307349 0.12703 0.440979C0.0423441 0.574609 9.85599e-07 0.726057 9.70802e-07 0.895322C9.49384e-07 1.14031 0.0936017 1.35857 0.280803 1.55011L4.86055 6L0.280802 10.4499C0.0936009 10.637 1.00079e-07 10.8552 7.82716e-08 11.1047C6.38634e-08 11.2695 0.0423432 11.4187 0.127029 11.5523C0.207259 11.6904 0.31646 11.7996 0.454632 11.8797C0.588348 11.9599 0.739892 12 0.909265 12C1.15441 12 1.36167 11.9154 1.53104 11.7461L6.67908 6.71492C6.78606 6.60802 6.86629 6.49666 6.91977 6.38085C6.9688 6.26503 6.99554 6.13808 7 6Z"
      fill="#1B1B1B"
    />
  </svg>
</template>

<script>
export default {
  name: "Chevron",
  props: {
    iconSize: {
      type: Number,
      default: 18,
    },
    orientation: {
        type: String,
        default: 'down',
    },
    pointer: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.chevron {
  -webkit-transition: -webkit-transform 0.2s ease-in-out;
  -ms-transition: -ms-transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out;

  &-left {
    transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
  }

  &-right {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }

  &-up {
    transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    -webkit-transform: rotate(270deg);
  }

  &-down {
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
  }
}

.pointer {
  cursor: pointer;

  path {
    transition: stroke 0.4s ease-in-out;
  }
}
</style>